import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import { fire } from "../../firebase/index";
import { doGetAdminLockslList } from "../../firebase/index";
import _ from "lodash";
import axios from "axios";
import TimeStamp from "react-timestamp";
import withAuthorization from "../../components/Authorization/withAuthorization";
import { FormControl, Popover, OverlayTrigger } from "react-bootstrap";
import "../../assets/css/mapview.css";
import "../../assets/css/header.css";

import { customLog } from "../../variables/Variables";

//https://tomchentw.github.io/react-google-maps/  //BACKUP LIBRARY

//Build the sidebar
//pull audit trail entries from firebase
//for -> most recent 100? entries place a pin
//decorate the pin
//paginate the sidebar

import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    auditTrailTitle: "Audit Trail List",
    selectTitle: "- Please Select Your lock Type -",
  },
  ja: {
    auditTrailTitle: "監査証跡リスト",
    selectTitle: "ロックを選択してください",
  },
  es: {
    auditTrailTitle: "Lista de Auditoría",
    selectTitle: "- Por favor, seleccione su tipo de candado -",
  },
});

const popover = (
  <Popover id="popover-basic" title="[Lock Name]">
    And here's some <strong>amazing</strong> content. It's very engaging. right?
  </Popover>
);

// const popover = (
//     <Popover id="popover-basic" title="[Lock Name]">
//         And here's some <strong>amazing</strong> content. It's very engaging. right?
// </Popover>
//     (this.state.myadminlocklistArray, lockData => {
//         return <option>
//             {lockData.ip45SerialNumber}
//         </option>;
//     })
// )

const LockedMarker = () => (
  <OverlayTrigger placement="right" overlay={popover}>
    <div>
      <div className="lockPin"></div>
      <div className="pulse"></div>
    </div>
  </OverlayTrigger>
);

const UnlockedMarker = () => (
  <OverlayTrigger placement="right" overlay={popover}>
    <div>
      <div className="unlockPin"></div>
      <div className="pulse"></div>
    </div>
  </OverlayTrigger>
);

class AuditTrailMapview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myadminlocklistArray: [],
      ATArray: [],
      selectedLock: "",
      selectedLockSerial: "",
      loading: true,
    };
    this.detectOnChangeEvent = this.detectOnChangeEvent.bind(this);
    this.renderMapMarkers = this.renderMapMarkers.bind(this);
    this.auditTrailMainCardComponent = this.auditTrailMainCardComponent.bind(
      this
    );
    this.auditTrailLockUnlockSubComponent = this.auditTrailLockUnlockSubComponent.bind(
      this
    );
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };
  componentWillMount() {
    // fire.database().ref("AuditTrail").child("A00022").orderByKey().once("value")
    //     .then(snapshot => {
    //         var tempArray = [];
    //         tempArray = this.snapshotToArray(snapshot);
    //         this.setState({
    //             ATArray: tempArray,
    //             loading: false
    //         });

    //     });

    axios
      .get(
        process.env.REACT_APP_FIREBASE_DATABASE +
          "/" +
          doGetAdminLockslList() +
          ".json?auth=" +
          process.env.REACT_APP_FIREBASE_DATABASE_SECRET
      )
      .then((response) => {
        this.setState({ myadminlocklistArray: response.data, loading: false });
      })
      .catch((err) => {
        customLog(err);
      });
  }
  static defaultProps = {
    center: {
      lat: 1.2757879270599066,
      lng: 103.79592443289555,
    },
    zoom: 14,
  };

  forceUpdateHandler() {
    this.forceUpdate();
  }

  detectOnChangeEvent(event) {
    var val = event.target.value;
    this.setState({
      selectedLock: val,
      count: 0,
    });
    var selectedLock = event.target.value;
    this.fetchSelectedLockFromAuditLocksList(selectedLock);
  }

  fetchSelectedLockFromAuditLocksList(selectedLockSerial) {
    fire
      .database()
      .ref("AuditTrail")
      .child(selectedLockSerial)
      .limitToFirst(5)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        tempArray = this.snapshotToArray(snapshot);
        this.setState({
          ATArray: tempArray,
          loading: false,
        });
        customLog(tempArray);
      });
  }

  renderDropdown() {
    return _.map(this.state.myadminlocklistArray, (lockData) => {
      return <option>{lockData.ip45SerialNumber}</option>;
    });
  }

  renderMapMarkers() {
    if (!this.state.ATArray) {
      return <div>{"NO DATA FOUND"}</div>;
    }

    if (this.state.loading) {
      return <div>{"LOADING"}</div>;
    } else {
      return _.map(this.state.ATArray, (index) => {
        if (index.lockedStatus === "UNLOCKED") {
          return <UnlockedMarker lat={index.Latitude} lng={index.Longitude} />;
        } else {
          return <LockedMarker lat={index.Latitude} lng={index.Longitude} />;
        }
      });
    }
  }
  auditTrailLockUnlockSubComponent(text) {
    if (text === "UNLOCKED") {
      return (
        <p style={{ color: "red", fontWeight: "bold", textAlign: "center" }}>
          {text}
        </p>
      );
    } else {
      return (
        <p style={{ color: "green", textAlign: "center", fontWeight: "bold" }}>
          {text}
        </p>
      );
    }
  }

  auditTrailMainCardComponent() {
    return _.map(this.state.ATArray, (index) => {
      return (
        <div className={"AuditTrailDiv"}>
          <p>{index.Placemark}</p>
          {this.auditTrailLockUnlockSubComponent(index.lockedStatus)}
          <TimeStamp time={index.time / 1000} format="full" includeDay />
          <p>{index.userEmail}</p>
          <hr></hr>
          {/* Look up the user's name? */}
        </div>
      );
    });
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    return (
      // Important! Always set the container height explicitly
      <div style={{ maxWidth: "95%", marginLeft: "auto", marginRight: "auto" }}>
        <div className="header">
          <h2>{localizationStrings.auditTrailTitle}</h2>
          <div
            id="mapViewDropDownContainer"
            style={{
              display: "flex",
              backgroundColor: "white",
              maxHeight: "120vh",
            }}
          >
            <div
              id="dropDownContainerMapView"
              style={{ width: "20%", height: "80vh", overflow: "scroll" }}
            >
              <div>
                <FormControl
                  componentClass="select"
                  placeholder="select"
                  onChange={this.detectOnChangeEvent}
                >
                  <option value="null"></option>
                  {this.renderDropdown()}
                </FormControl>
              </div>

              {this.auditTrailMainCardComponent()}
            </div>

            <div id="mapViewMainContainer">
              <div id="mapViewContainer">
                <GoogleMapReact
                  // bootstrapURLKeys={{ key: "AIzaSyBDnPdco2BZS-03O1xndKUzIZ9UmCX01Rw" }}
                  // bootstrapURLKeys={{ key: "AIzaSyC5FRTGktJyF0lD9PMyPh4ipXN2ZmyEbmI" }}
                  bootstrapURLKeys={{
                    key: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
                  }}
                  defaultCenter={this.props.center}
                  defaultZoom={this.props.zoom}
                >
                  {/* <SampleMapMarker
                                        lat={1.2757879270599066}
                                        lng={103.79592443289555}
                                        text="X"
                                    /> */}
                  {this.renderMapMarkers()}
                </GoogleMapReact>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(AuditTrailMapview);
